<template>
    <div v-loading="loading" :class="componentWidth < 768 ? 'full-width-mobile' : 'full-width'" ref="holderCardPart">
        <div class="record-box">
            <div :span="imgSpan">
                <div :class="componentWidth < 768 ? 'image-part-mobile' : 'image-part'">
                    <div class="card-img" @click="clickCardImg" >
                        <img :src="imgUrl" style="">
                    </div>
                </div>
            </div>

            <div :span="contentSpan">
                <div :class="componentWidth < 768 ? 'content-box-mobile' : 'content-box'">
                    <el-row>
                        <el-col :span="textSpan">
                            <div class="text-part" style="padding-top: 0">{{card.workcompany}}</div>
                        </el-col>

                        <el-col :span="textSpan">
                            <div class="text-part">{{card.name}}</div>
                        </el-col>

                        <el-col :span="textSpan">
                            <div class="text-part">{{card.login}}</div>
                        </el-col>

                        <el-col :span="textSpan">
                            <div class="text-part">{{card.telephone}}</div>
                        </el-col>

                    </el-row>
                </div>
            </div>
        </div>

        <!--   操作按鈕     -->
        <div :class="componentWidth < 768 ? 'btns-part-mobile' : 'btns-part'">
<!--            <el-button-->
<!--                :size="btnSize"-->
<!--                @click="clickChat"-->
<!--                class="btn"-->
<!--                circle-->
<!--            >-->
<!--                <font-awesome-icon icon="fa-solid fa-comments" />-->
<!--            </el-button>-->

<!--            &lt;!&ndash;            <el-button class="btn" type="info" circle ><font-awesome-icon icon="fa-solid fa-shuffle" /></el-button>&ndash;&gt;-->
<!--            <el-button-->
<!--                :size="btnSize"-->
<!--                @click="clickShare"-->
<!--                class="btn"-->
<!--                circle-->
<!--            >-->
<!--                <font-awesome-icon icon="fa-solid fa-share-nodes" />-->
<!--            </el-button>-->

<!--            <el-button-->
<!--                :size="btnSize"-->
<!--                @click="clickDelete"-->
<!--                v-if="null == showDelBtn || true == showDelBtn"-->
<!--                class="btn"-->
<!--                type="danger"-->
<!--                circle-->
<!--            >-->
<!--                <font-awesome-icon icon="fa-solid fa-xmark" />-->
<!--            </el-button>-->

            <el-button type="primary" text @click="clickCardImg" tkey="查看">{{i18n.tkey("lang_check")}}</el-button>
        </div>
    </div>
</template>

<script setup>
import {computed, getCurrentInstance, ref, onMounted, toRef, inject} from 'vue'
import util from "@/util/util"

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faComments, faShuffle, faShareNodes, faXmark } from '@fortawesome/free-solid-svg-icons'
import {ElMessage, ElMessageBox} from "element-plus";
import api from "@/request/api"
import { useShareinfo } from '@/stores/shareinfo'
import myUtil from "@/util/util";

const shareInfoRef = toRef(useShareinfo())

library.add(faComments, faShuffle, faShareNodes, faXmark)

const { proxy } = getCurrentInstance()

const staticPath = process.env.BASE_URL

const { clickCardChatBtn } = inject('myCardViewFunc', { clickCardChatBtn: () => {} })
const { goCardView } = inject('phoneView', { goCardView: jumpToCardView })

const imgUrl = computed(() => {
    if (null != props.card){
        if (myUtil.isEmpty(props.card.addinfo8)){
            return util.generateStaticUrl(`/MPic/ZZ/${props.card.cardinfo}`)
        }else{
            return util.generateStaticUrl(props.card.addinfo8)
        }

    }

    return null
})

const btnSize = computed(() => {
    let size = ""

    if (componentWidth.value < 768){
        size = ""
    }

    return size

})

const props = defineProps(["card", "letterKey", "showDelBtn"])
const emits = defineEmits(['delete-complete'])

const componentWidth = ref(375)

const imgSpan = ref(5)
const contentSpan = ref(19)
const labelSpan = ref(4)
const textSpan = ref(24)

const loading = ref(false)

const i18n = inject("i18n")

function clickDelete(){
    ElMessageBox.confirm(i18n.tkey("lang_delete_confirm"), {
        confirmButtonText: i18n.tkey("lang_sure"),
        cancelButtonText: i18n.tkey("lang_cancel"),
    })
        .then(() => {
            deleteRecord()
        })
        .catch(() => {
            // catch error
        })
}

function deleteRecord(){
    loading.value = true

    const request = api.delRecord1
    const params = request.getParams()

    params.id = props.card.record1Id

    request.send(params, deleteCallback)

}

function deleteCallback(res){
    loading.value = false
    if (res.code == 200){
        util.alertSuccess("刪除成功")
        emits("delete-complete", props.card.record1Id, props.letterKey)
    }else{
        util.alertError(res.msg)
    }
}

function clickShare(){
    shareInfoRef.value.cardId = props.card.id
}

function clickChat(){
    clickCardChatBtn(props.card.login)
}

function clickCardImg(){
    goCardView(props.card.id)
}

function jumpToCardView(id){
    proxy.$router.push({
        name: "cardFromID",
        params: {
            cardId: id
        }
    })
}

onMounted(() => {
    componentWidth.value = proxy.$refs.holderCardPart.offsetWidth

    if (componentWidth.value < 768){
        imgSpan.value = 11
        contentSpan.value = 13
        labelSpan.value = 6
        textSpan.value = 24
    }
})
</script>

<style scoped>
.full-width{
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    position: relative;
}

.full-width-mobile {
    width: 100%;
    padding: 20px 0;
    box-sizing: border-box;
    position: relative;
    border-bottom: 1px #F2F6FC solid;
}

.record-box {
    display: flex;
}

.content-box {
    width: 100%;
}

.content-box-mobile {
    width: 100%;
    padding-bottom: 50px;
}

.label-part {
    padding: 8px 11px;
    border: 1px solid #ebeef5;
    font-weight: 700;
    color: #606266;
    background: #f5f7fa;
    box-sizing: border-box;
    line-height: 23px;
    font-size: 14px;
    user-select: none;
}

@media screen and (min-width: 768px) {
    .text-part {
        padding: 8px 0;
        /*border: 1px solid #ebeef5;*/
        color: #303133;
        box-sizing: border-box;
        font-weight: 400;
        line-height: 14px;
        font-size: 14px;
        text-align: left;
    }
}

@media screen and (max-width: 768px) {
    .text-part {
        padding: 5px 0;
        /*border: 1px solid #ebeef5;*/
        color: #303133;
        box-sizing: border-box;
        font-weight: 400;
        line-height: 12px;
        font-size: 12px;
        text-align: left;
    }
}

.btns-part {
    position: absolute;
    bottom: 30px;
    right: 30px;
}

.btns-part-mobile {
    position: absolute;
    width: 100%;
    text-align: right;
    bottom: 20px;
    left: 0;
}

.btns-part,.btns-part-mobile .btn{
    font-size: 16px;
}

.image-part {
    width: 200px;
    margin-right: 20px;
}

.image-part-mobile {
    width: 160px;
    margin-right: 20px;
}

.card-img {
    width: 100%;
    height: 100%;
}

.image-part .card-img img{
    width: 100%;
    object-fit: scale-down;
    height: 130px;
    box-sizing: border-box;
    border-radius: 3px;
    border: 1px #E4E7ED solid;
}

.image-part-mobile .card-img img{
    width: 100%;
    object-fit: scale-down;
    height: 105px;
    box-sizing: border-box;
    border-radius: 3px;
    border: 1px #E4E7ED solid;
}

</style>